import Category from '@/models/Category'
import Avatar from '@/models/Avatar'
import Api from '@/services/api'
import { each, find } from 'lodash'

export default {
  namespaced: true,
  state: {
    list: [],
    listMeta: {
      current_page: 0,
      last_page: 1,
    },
    categoryDetails: null,
  },

  mutations: {
    setCategoryList(state, categories) {
      each(categories, (category) => {
        const exist = find(state.list, { id: category.id })
        if (!exist) {
          state.list.push(new Category(category))
        }
      })
    },

    clearCategoryList(state) {
      state.list = []
    },

    setCategoryListMeta(state, meta) {
      state.listMeta = meta
    },

    setCategoryDetails(state, category) {
      if (category instanceof Category) {
        state.categoryDetails = category
      } else {
        state.categoryDetails = new Category(category)
      }
    },

    clearCategoryDetails(state) {
      state.categoryDetails = {
        label: null,
        description: null,
        image_url: null,
      }
    },

    setSelectedCategoryAvatar(state, avatar) {
      if (avatar instanceof Avatar) {
        state.categoryDetails.avatar = avatar
      } else {
        state.categoryDetails.avatar = new Avatar(avatar)
      }
    },

    categoryAvatarRemoved(state) {
      state.userDetails.avatar = null
    },
  },

  actions: {
    async getCategories({ commit }, params) {
      const query = Category.page(params.page || 1)

      if (params.search) {
        query.where('search', params.search)
      }

      if (params.sort_direction) {
        query.params({ sort_direction: params.sort_direction })
      }

      let loadPrams = {
        limit: 1,
        sort_direction: params.sort_direction,
        sort_by: params.sort_by,
      }

      if (params.limit) {
        loadPrams.limit = params.limit
      }

      const res = await query.params(loadPrams).get()
      commit('clearCategoryList')
      commit('setCategoryList', res.data)
      commit('setCategoryListMeta', res.meta)
    },

    async getAllCategories({ commit }, params) {
      const query = Category.page(params.page || 1)

      if (params.search) {
        query.where('search', params.search)
      }

      if (params.sort_direction) {
        query.params({ sort_direction: params.sort_direction })
      }

      let loadPrams = {
        limit: 1,
        sort_direction: params.sort_direction,
        sort_by: params.sort_by,
      }

      if (params.limit) {
        loadPrams.limit = params.limit
      }

      const res = await query.params(loadPrams).get()
      commit('clearCategoryList')
      commit('setCategoryList', res.data)
      commit('setCategoryListMeta', res.meta)
    },

    async getCategoryDetails({ commit }, id) {
      const { data } = await Api.get(`admin/categories/${id}`)
      commit('setCategoryDetails', data.data)
    },

    async changeAvatar({ commit }, formData) {
      const { data } = await Api.post(
        `users/${formData.get('user_id')}/avatar`,
        formData
      )
      commit('setSelectedCategoryAvatar', data.data)
    },

    async updateCategory({ commit }, form) {
      let formData = new FormData()

      formData.append('label', form.label)

      if (form.description) {
        formData.append('description', form.description)
      }

      if (form.photo) {
        formData.append('photo', form.photo)
      }

      if (form.icon) {
        formData.append('icon', form.icon)
      }

      if (form.id) {
        formData.append('id', form.id)
      }

      const { data } = await Api.post(`admin/categories/${form.id}`, formData)
      commit('setCategoryDetails', data.data)
    },

    async exportToExcel() {
      const file = await Api.get('/users/export', { responseType: 'blob' })
      return file
    },
  },
}
